import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { NotificationService } from "../../../config/notification.service";
import { NavService } from '../nav.service';
import { ContentService } from './content.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

export const Breakpoints = {
  Handset: '(max-width: 991px)'
};

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html'
})

export class ContentComponent implements OnInit {

  public page = 1;
  public rows = 5;
  public total = 0;
  subscription: any;
  subscription1: any;
  PRCount: any;
  public MenuData: any = [];
  public accessData: any = [];
  public navItems: any = [];

  @ViewChild('drawer') drawer: any;

  public config: PerfectScrollbarConfigInterface = {
    useBothWheelAxes: true, suppressScrollX: false, suppressScrollY: false
  };

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset).pipe(
    map(result => result.matches),
    shareReplay()
  );

  constructor(
    private breakpointObserver: BreakpointObserver,
    public navService: NavService,
    public toster: NotificationService,
    private contentService: ContentService
  ) { }

  ngOnInit() {
    let user_id = sessionStorage.getItem('id');
    this.contentService.getSidebarById();
    this.getParentMenu(user_id);
    this.subscription = this.contentService.getSideMenuChangeEmitter()
      .subscribe(item => this.getParentMenu(user_id));
    this.subscription1 = this.contentService.sidebarMenu.subscribe((dataValue: any) => {
      this.navItems = dataValue['data'];
    })
  }

  closeSideNav() {
    if (this.drawer._mode == 'over') {
      this.drawer.close();
    }
  }

  getParentMenu(id) {
    this.navService.listParentMenu(id).subscribe((result: any) => {
      if (result['code'] == 200) {
        this.navItems = result['data'];
      }
      else {
        this.toster.showError('getParentMenu', '');
      }
    });
  }
}
